export default __webpack_public_path__ + "static/media/valdano_mobile.250d9fb1.jpg";